var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.videos.length
    ? _c(
        "div",
        {
          staticClass: "steam-videos insicht insicht--fade-in",
          class: [_vm.moduleSpacing],
        },
        [
          _c(
            "div",
            { staticClass: "steam-videos__tabs", class: [_vm.bgColor] },
            _vm._l(_vm.videos, function (video, index) {
              return _c(
                "button",
                {
                  key: "steam-video-tab-" + index,
                  staticClass: "steam-videos__tab",
                  class: {
                    "steam-videos__tab--active": _vm.activeTab == index,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onTabClick(index)
                    },
                  },
                },
                [
                  _c(_vm.iconComponent(video.icon), {
                    tag: "component",
                    staticClass: "steam-videos__tab-icon",
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "steam-videos__tab-title",
                    domProps: { innerHTML: _vm._s(video.title) },
                  }),
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("h3", {
            staticClass: "steam-videos__title",
            domProps: { innerHTML: _vm._s(_vm.activeTitle) },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "steam-videos__video" }, [
            _c(
              "div",
              { staticClass: "media-container media-container--landscape" },
              [
                _vm.showPoster
                  ? _c(
                      "figure",
                      {
                        staticClass: "steam-videos__video-poster",
                        on: {
                          click: function ($event) {
                            return _vm.onPosterClick()
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "steam-videos__video-poster-element",
                          attrs: {
                            srcset: _vm.activeVideo.poster.srcset,
                            src: _vm.activeVideo.poster.src,
                            alt: _vm.activeVideo.title,
                            "data-object-fit": "",
                            loading: "lazy",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "steam-videos__video-poster-button",
                            attrs: { type: "button" },
                          },
                          [
                            _c("SVGPlay", {
                              staticClass: "steam-videos__video-poster-icon",
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  : _c("iframe", {
                      staticClass: "steam-videos__video-iframe",
                      attrs: {
                        src: _vm.videoUrl,
                        frameborder: "0",
                        allow:
                          "accelerometer; autoplay; fullscreen; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                        allowfullscreen: "",
                      },
                    }),
              ]
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }